import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useOnboardingNavigate } from '@/hooks/useOnboardingNavigate';
import { trackTermsEvent } from '@/helpers/analytics';
import { termsCopy } from '@/Pages/Terms/copy';
import '@/Pages/Terms/TermsPage.sass';

export function TermsFooter(): JSX.Element {
  const { navigateTo, isNavigating } = useOnboardingNavigate();

  return (
    <Box component="footer" className="terms-footer" data-testid="terms-footer">
      <Button
        type="button"
        variant="text"
        color="inherit"
        startIcon={<ArrowBackRoundedIcon aria-hidden fontSize="small" />}
        disabled={isNavigating}
        className="terms-footer__back"
        data-testid="terms-back-button"
        onClick={() => {
          void trackTermsEvent({ name: 'terms_back_click' });
          navigateTo('/welcome');
        }}
      >
        {termsCopy.back}
      </Button>

      <Box
        className="terms-footer__security"
        data-testid="terms-security-message"
      >
        <LockOutlinedIcon aria-hidden fontSize="small" />
        <Typography component="span" variant="caption">
          {termsCopy.securityMessage}
        </Typography>
      </Box>
    </Box>
  );
}
